import React from "react"
import { Link } from "react-router-dom"
import { Card, CardBody, Col, Collapse, Container, Form, Input, Label, Media, Row, Table, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap"
import ApiRest from "../../ayudas/apiRest"
import Breadcrumbs from '../../components/Common/Breadcrumb'
import ModalEnsamble from "../../components/ModalPersonalizado/ModalEnsamble"
import _valid from "../../validations"
import { MDBBtn, MDBIcon } from "mdbreact";
import Select from 'react-select'
import toastr from "toastr"


export default class ensambleDepartamento extends React.Component {
    constructor(props) {
        super(props);

        this.apiRest = new ApiRest(props);

        this.state = {
            registro: _valid(this.props.location.registro) ? this.props.location.registro : {

            },
            colapsar: true,
            listaColaborador: [],
            selectedOption: null,
            estadoModal: false,
            areasTrabajo: [],
            area: undefined,
        };
        this.handleChange = this.handleChange.bind(this);
        this.setearColaborador = this.setearColaborador.bind(this);
        this.setearAreaTrabajo = this.setearAreaTrabajo.bind(this);
        this.guardarEnsamble = this.guardarEnsamble.bind(this);
        this.enviarEnsamble = this.enviarEnsamble.bind(this);
    }

    componentDidMount() {
        //console.log(this.state.registro);
        this.obtenerListaDeColaboradores();
        this.obtenerAreasTrabajo();
    }

    guardarEnsamble = () => {
        //console.log('Guardar');
        const {
            registro,
        } = this.state;

        if (_valid(registro.estado)) {
            this.apiRest.put('/ensamble_update/' + registro.id, registro).then(resultado => {
                if (resultado.exitoso) {
                    toastr.success('Actualizado exitosamente!');
                    this.props.history.replace('/ensamblePorDepartamento')
                } else if (resultado.response.status === 400) {
                    toastr.error(resultado.data.mensajeError);
                } else {
                    toastr.error('Vaya! Ha ocurrido un error, por favor intenta nuevamente.');
                }
            });
        } else {
            toastr.error('Debe Seleccionar un Estado.');
        }
    }

    enviarEnsamble = () => {
        const {
            area,
            registro,
            selectedOption
        } = this.state;

        //console.log('Enviar a colaborador');
        if (this.verificarDatos()) {
            let asignarActivo = {
                cantidad: registro.cantidad,
                idAreaTrabajo: area.value,
                idArticulo: registro.Articulo.id,
                idColaborador: selectedOption.value,
                idEnsamble: registro.id,
            }

            this.apiRest.get('/autheticarColaborador/' + asignarActivo.idColaborador).then(resultado => {
                if (resultado.exitoso) {
                    let estado = resultado.data
                    if (estado == 'Aceptado') {
                        //console.log(asignarActivo)
                        this.apiRest.post('/entregarActivoEnsamblado/' + asignarActivo.idColaborador, asignarActivo).then(resultado => {
                            if (resultado.exitoso) {
                                toastr.success(resultado.data);
                                this.props.history.replace('/ensamblePorDepartamento')
                            } else {
                                toastr.error('Vaya! Ha ocurrido un error, por favor intenta nuevamente.');
                            }
                        });
                    } else {
                        toastr.error('Datos incompletos del colaborador no esta asociado a un Departamento.');
                    }
                }
            });
        }
    }

    verificarDatos = () => {
        const {
            selectedOption,
            area
        } = this.state;

        let contador = 0;

        if (_valid(selectedOption)) {
            contador++;
        } else {
            toastr.error('Debe Seleccionar un Colaborador.');
        }

        if (area) {
            contador++;
        } else {
            toastr.error('Debe Seleccionar un Area de Trabajo.');
        }

        if (contador === 2) {
            return true;
        } else {
            return false;
        }
    }

    obtenerListaDeColaboradores = () => {
        this.apiRest.get('/colaborador').then(resultado => {
            if (resultado.exitoso) {
                //console.log(resultado);
                this.setState({ listaColaborador: this.formatoSelect(resultado) })
            }
        });
    }

    obtenerAreasTrabajo = () => {
        this.apiRest.get('/getAreaTrabajo').then(respuesta => {
            if (respuesta.exitoso) {
                this.setState({ areasTrabajo: respuesta.data });
            } else {
                this.setState({ areasTrabajo: [] });
            }
        });
    }

    setearColaborador = (colaborador) => {
        if (_valid(colaborador)) {
            this.setState({ selectedOption: colaborador })
        }
        else {
            this.setState({ selectedOption: null })
        }
    }

    setearAreaTrabajo = (area) => {
        if (_valid(area)) {
            this.setState({ area })
        }
        else {
            this.setState({ area: undefined })
        }
    }

    formatoSelect = valores => valores.data.map(i => ({ value: i.id, label: 'No: ' + i.numero_empleado + ' Nombre:' + i.nombres + ' ' + i.apellidos + ' Dpi:' + i.dpi }));

    colapsar() {
        this.setState(estadoAnterior => ({ colapsar: !estadoAnterior.colapsar }));
    }

    handleChange = ({ target: { name, value } }) => {

        this.setState({
            registro: {
                ...this.state.registro,
                [name]: value
            }
        });
    }

    render() {
        const {
            registro,
            colapsar,
            listaColaborador,
            selectedOption,
            estadoModal
        } = this.state;

        return (
            <React.Fragment>
                <div className="page-content">
                    <Container fluid>
                        <Breadcrumbs title="Formulario" breadcrumbItem="Ensamble" />
                        <Row>
                            <Col className="col-12">
                                <Card>
                                    <CardBody>
                                        <Link onClick={() => this.colapsar()} className="text-dark" to="#">
                                            <div className="p-4">
                                                <Media className="d-flex align-items-center">
                                                    <div className="me-3">
                                                        <i className="uil uil-receipt text-primary h2"></i>
                                                    </div>
                                                    <div className="flex-1 overflow-hidden">
                                                        <h5 className="font-size-16 mb-1">Ensamble/Almacenamiento</h5>
                                                        <p className="text-muted text-truncate mb-0">Por favor, proporciona los datos.</p>
                                                    </div>
                                                    <i className="mdi mdi-chevron-up accor-down-icon font-size-24"></i>
                                                </Media>
                                            </div>
                                        </Link>
                                        <Collapse isOpen={colapsar}>
                                            <Form>
                                                <Row>
                                                    <Col lg={12}>
                                                        {/*<ModalEnsamble registro={registro} props={this.props} />*/}
                                                        <Row className="col-12">
                                                            <Col size={4}>
                                                                <Label htmlFor="" className="form-label">
                                                                    Codigo: {_valid(registro) ? registro.Articulo.codigo : "null"}
                                                                </Label>
                                                            </Col>
                                                            <Col size={4}>
                                                                <Label htmlFor="" className="form-label">
                                                                    Nombre: {_valid(registro) ? registro.Articulo.nombre : "null"}
                                                                </Label>
                                                            </Col>
                                                            <Col size={4}>
                                                                <Label htmlFor="" className="form-label">
                                                                    Marca: {_valid(registro) ? registro.Articulo.marca : "null"}
                                                                </Label>
                                                            </Col>
                                                        </Row>
                                                    </Col>
                                                    <p />
                                                    <Col lg={12}>
                                                        <Row className="col-12">
                                                            <Col size={4}>
                                                                <Label htmlFor="" className="form-label">
                                                                    Descripcion: {_valid(registro) ? registro.Articulo.descripcion : "null"}
                                                                </Label>
                                                            </Col>
                                                            <Col size={4}>
                                                                <Label htmlFor="" className="form-label">
                                                                    Cantidad: {_valid(registro) ? registro.cantidad : "null"}
                                                                </Label>
                                                            </Col>
                                                            <Col size={4}>
                                                                <Label htmlFor="observaciones" className="form-label">
                                                                    Observaciones: {_valid(registro) ? registro.observaciones : "null"}
                                                                </Label>
                                                                {/*<Input
                                                                    value={registro.observaciones || ""}
                                                                    onChange={this.handleChange}
                                                                    name="observaciones"
                                                                    type="textarea"
                                                                    className="form-control"
                                                                    placeholder="Ingrese una observación"
                                                                />*/}
                                                            </Col>
                                                        </Row>
                                                    </Col>
                                                    <Col>
                                                        <Row className="col-12">
                                                            {
                                                                _valid(registro) && registro.cantidad_en_movimiento === 0 ?
                                                                    <Col size={4}>
                                                                        <Label htmlFor="" className="form-label">
                                                                            Estado
                                                                        </Label>
                                                                        {
                                                                            _valid(registro) && registro.estado === "6" ?
                                                                                " Entregado" :
                                                                                <select
                                                                                    value={registro.estado || ""}
                                                                                    onChange={this.handleChange}
                                                                                    name="estado"
                                                                                    className="form-control"
                                                                                >
                                                                                    <option value="">Seleccione una opción</option>
                                                                                    <option value="4">Ensamble</option>
                                                                                    <option value="5">Almacenaciento</option>
                                                                                    <option value="6">Entregar</option>
                                                                                </select>
                                                                        }
                                                                    </Col>
                                                                : registro.cantidad_en_movimiento > 0 ? 'Activo entregado' : ''
                                                            }
                                                            <Col size={4}></Col>
                                                            <Col size={4}></Col>
                                                        </Row>
                                                    </Col>
                                                    <p />
                                                    {
                                                        _valid(registro) && registro.estado === "6" ?
                                                            <Col lg={12}>
                                                                <ModalHeader>
                                                                    <h5 className="font-size-16 mb-1">Formulario para Entregar</h5>
                                                                </ModalHeader>
                                                                <ModalBody>
                                                                    <Row className="col-12">
                                                                        <Col size={4}>
                                                                            <Label htmlFor="" className="form-label">
                                                                                Colaborador:
                                                                            </Label>
                                                                            <Select
                                                                                name="colaborador"
                                                                                options={listaColaborador}
                                                                                value={selectedOption}
                                                                                onChange={this.setearColaborador}
                                                                                className="basic-single"
                                                                                classNamePrefix="select"
                                                                                placeholder="Buscar"
                                                                                isClearable={true}
                                                                                isSearchable={true}
                                                                                noOptionsMessage={() => "Cargando..."}
                                                                            />
                                                                        </Col>
                                                                        <Col size={4}>
                                                                            <Label htmlFor="name" className="form-label">
                                                                                Ubicaci&oacute;n Area Trabajo
                                                                            </Label>
                                                                            <Select
                                                                                name="area"
                                                                                value={this.state.area}
                                                                                options={this.state.areasTrabajo}
                                                                                onChange={this.setearAreaTrabajo}
                                                                            >
                                                                            </Select>
                                                                        </Col>
                                                                    </Row>
                                                                </ModalBody>
                                                            </Col>
                                                            : ''
                                                    }
                                                    <p />
                                                    <Col lg={12} className="text-end">
                                                        {
                                                            _valid(registro) && registro.cantidad_en_movimiento === 0 ?
                                                            <MDBBtn className="waves-effect" color="success" onClick={() =>
                                                                _valid(registro) && registro.estado === '6' ? this.enviarEnsamble() : this.guardarEnsamble()
                                                            }>
                                                                <MDBIcon icon="fas fa-user-check" /> {' '}
                                                                Guardar
                                                            </MDBBtn>
                                                            :''
                                                        }
                                                        {' '}
                                                        <MDBBtn className="waves-effect" color="warning" onClick={() => { this.props.history.replace('/ensamblePorDepartamento') }}>
                                                            <MDBIcon icon="fas fa-arrow-left" /> {' '}
                                                            Regresar
                                                        </MDBBtn>
                                                    </Col>
                                                </Row>
                                            </Form>
                                        </Collapse>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>

                    </Container>
                </div>
            </React.Fragment>
        );
    }
}